import { render, staticRenderFns } from "./SelectCase.vue?vue&type=template&id=21994b08&"
import script from "./SelectCase.vue?vue&type=script&lang=js&"
export * from "./SelectCase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/saas-tool/client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('21994b08')) {
      api.createRecord('21994b08', component.options)
    } else {
      api.reload('21994b08', component.options)
    }
    module.hot.accept("./SelectCase.vue?vue&type=template&id=21994b08&", function () {
      api.rerender('21994b08', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/SelectCase.vue"
export default component.exports